import { TEMPLATE_TYPES } from "../constants";

const firstFilled = (source, keys) => {
  for (const key of keys) {
    const value = source?.[key];
    if (typeof value === "string" && value.trim() !== "") return value.trim();
    if (typeof value === "number") return String(value);
  }
  return "";
};

export const getBookTitle = (book) => firstFilled(book, ["title", "name"]);

export const getBookCover = (book) =>
  firstFilled(book, [
    "cover",
    "coverUrl",
    "coverImage",
    "image",
    "imageUrl",
    "picture",
    "pictureUrl",
    "thumbnail",
  ]);

export const getBookUrl = (book) =>
  firstFilled(book, ["selling_url", "sellingUrl", "url"]);

export const getBookAuthors = (book) =>
  (Array.isArray(book?.authors) ? book.authors : [])
    .map((author) =>
      typeof author === "string"
        ? author
        : `${author?.firstName || ""} ${author?.lastName || ""}`.trim(),
    )
    .filter((name) => name !== "")
    .join(", ");

export const formatBook = (book) => {
  const price = firstFilled(book, ["price", "amount"]);

  return {
    id: book?.id,
    type: TEMPLATE_TYPES["BOOK_LAYOUT"],
    bookTitle: getBookTitle(book),
    bookCover: getBookCover(book),
    bookAuthors: getBookAuthors(book),
    bookUrl: getBookUrl(book),
  };
};
